import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './routing/app-routing.module';
import { InternalizationModule } from './i18n/i18n.module';

@NgModule({
  imports: [
    AppRoutingModule,
    InternalizationModule
  ],
  exports: [RouterModule]
})
export class AppConfigModule {
}



// WEBPACK FOOTER //
// ./src/config/app-config.module.ts